import { getUrl } from '../../config';
import React from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import axios from "axios";
import {
  Tooltip,
  IconButton as MuiIconButton,
} from "@mui/material";
import UpdateIcon from '@mui/icons-material/Update';
import ModalChangelog from '../linar/Modal/ModalChangelog';

const IconButton = styled(MuiIconButton)`
  svg {
    width: 20px;
    height: 20px;
    transition: transform 0.2s ease-in-out;
  }
  border-radius: 8px;
  padding: 8px;
  transition: all 0.2s ease-in-out;
  &:hover {
    background: ${(props) =>
      props.theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.06)"
        : "rgba(0, 0, 0, 0.04)"};
    color: ${(props) => props.theme.palette.primary.main};
    svg {
      transform: scale(1.05);
    }
  }
`;

function NavbarChangelogIcon() {
  const { t } = useTranslation();
  const [changelogModalOpen, setChangelogModalOpen] = React.useState(false);
  const [lastChangelog, setLastChangelog] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const fetchLastChangelog = async () => {
    try {
      setLoading(true);
      const response = await axios.get(getUrl() + '/api/changelogs/latest', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      });
      if (response.data.status === 'success' && response.data.data) {
        setLastChangelog(response.data.data);
      }
    } catch (error) {
      console.error('Erreur lors de la récupération de la dernière mise à jour:', error);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchLastChangelog();
  }, []);

  const handleOpenModal = () => {
    if (lastChangelog) {
      setChangelogModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setChangelogModalOpen(false);
  };

  if (!lastChangelog) {
    return null;
  }

  return (
    <React.Fragment>
      <Tooltip title="Dernière mise à jour">
        <IconButton
          onClick={handleOpenModal}
          color="inherit"
          size="large"
        >
          <UpdateIcon />
        </IconButton>
      </Tooltip>
      {changelogModalOpen && lastChangelog && (
        <ModalChangelog
          open={changelogModalOpen}
          onClose={handleCloseModal}
          updates={[lastChangelog]}
          onMarkAsRead={() => {}}
          hideMarkAsRead={true}
        />
      )}
    </React.Fragment>
  );
}

export default NavbarChangelogIcon;

